<template>


    <div id="webId"  class="xuanfu" @mousedown="down" @touchstart="down"
          @mousemove="move" @touchmove.prevent="move"   
          @mouseup="end" @touchend="end" ref="moveDiv">
        <div>你的web页面</div>
        <!-- 如果碰到滑动问题，1.1 请检查这里是否属于同一点。 -->
        <!-- 悬浮的HTML -->
        <div 
        >
          <div class="yuanqiu" id="yuanqiu">
              55552020年8月10日14:45:24
          </div>
          <button @click="close_p">close_p</button>
    </div>
  </div>


</template>

<style scoped>
.xuanfu {
    height: 4.5rem;
    width: 4.5rem;
    /* 如果碰到滑动问题，1.3 请检查 z-index。z-index需比web大一级*/
    z-index: 999;
    position: fixed;
    top: 4.2rem;
    right: 3.2rem;
    border-radius: 0.8rem;
    background-color: rgba(0, 0, 0, 0.55);
  }
  .yuanqiu {
    height: 2.7rem;
    width: 2.7rem;
    border: 0.3rem solid rgba(140, 136, 136, 0.5);
    margin: 0.65rem auto;
    color: #000000;
    font-size: 1.6rem;
    line-height: 2.7rem;
    text-align: center;
    border-radius: 100%;
    background-color: #ffffff;
  }
</style>

<script>
	// var _this;
    // @ is an alias to /src
    export default {
  components: {},
		created() {
            // _this = this;
            // $("#yuanqiu").hide();
            setTimeout(function(){
            window.fbq('trackCustom', 'buy_cart_add', {"id": 666});
            window.console.log("来了 ");
            },3333)
        },
        data() {
			return {	
                flags: false,
                position: { x: 0, y: 0 },
                nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',
			}
        },
        methods: {
            // 实现移动端拖拽
            down(){
                this.flags = true;
                var touch;
                if(event.touches){
                    touch = event.touches[0];
                }else {
                    touch = event;
                }
                this.position.x = touch.clientX;
                this.position.y = touch.clientY;
                this.dx = this.$refs.moveDiv.offsetLeft;
                this.dy = this.$refs.moveDiv.offsetTop;
            },
            move(){
                if(this.flags){
                var touch ;
                if(event.touches){
                    touch = event.touches[0];
                }else {
                    touch = event;
                }
                this.nx = touch.clientX - this.position.x;
                this.ny = touch.clientY - this.position.y;
                this.xPum = this.dx+this.nx;
                this.yPum = this.dy+this.ny;
                this.$refs.moveDiv.style.left = this.xPum+"px";
                this.$refs.moveDiv.style.top = this.yPum +"px";
                //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
                // document.addEventListener("touchmove",function(){
                //     event.preventDefault();
                // },false);
                }
            },
            //鼠标释放时候的函数
            end(){
                this.flags = false;
            },
            go(){
                // if(this.source == 'close'){
                //     // this.$router.push('personal');
                //     this.$router.push(localStorage.getItem('reg_from'))
                //     this.user_coupons = [];
                // }else if(this.source == 'exchange'){
                //     this.$router.push('/')
                // }else{
                //     this.$router.push(localStorage.getItem('reg_from'))
                // }                
                var buy_now_goods_info_tologin = localStorage.getItem("buy_now_goods_info_tologin");
                if(buy_now_goods_info_tologin != "" && buy_now_goods_info_tologin != null){
                    window.console.log(buy_now_goods_info_tologin);alert("good");
                    return;
                        // var buy_now_goods_info_tologin_json = JSON.parse(buy_now_goods_info_tologin);
                        // localStorage.setItem('buy_now_goods_info', buy_now_goods_info_tologin);
                        // localStorage.removeItem("buy_now_goods_info_tologin");
                        // this.$router.push({path: 'pay', query: {ids: buy_now_goods_info_tologin_json.goods_id, buy_type: 'goods'}})
                }else{
                    var reg_from = localStorage.getItem('reg_from');
                    if(reg_from == ""){
                        reg_from = "personal";
                    }
                    this.$router.push(reg_from);
                }
            },
            close_p(){
                alert("来了");
                // this.$router.push(localStorage.getItem('reg_from'))
                this.go();
            },
        }
    }
</script>